export const normalizeLinkusFailureCause = (cause) => {
  if (!cause) {
    return "";
  }
  if (typeof cause === "string") {
    return cause.toLowerCase();
  }
  if (cause instanceof Error) {
    return String(cause.message || "").toLowerCase();
  }
  const parts = [cause.cause, cause.message, cause.reason, cause.status_code, cause.name]
    .filter(Boolean)
    .map(String);
  return parts.join(" ").toLowerCase();
};

export const isCallerCancelCause = (causeText) =>
  /cancel|canceled|cancelled|decline|not answer|no answer|486|487|603|408/.test(causeText || "");

export const isAckTimeoutCause = (causeText) => /ack.*timeout|timeout.*ack/.test(causeText || "");

/** JsSIP RTCSession is already past answer (STATUS_ANSWERED and beyond). */
export const isAlreadyAnsweredCause = (causeText) =>
  /invalid status:\s*(5|6|9)/.test(causeText || "");

export const isAlreadyAnsweredError = (error) =>
  isAlreadyAnsweredCause(normalizeLinkusFailureCause(error));

export const getRtcSession = (session) => session?.RTCSession ?? null;

export const isRtcSessionEstablished = (session) => {
  const rtc = getRtcSession(session);
  if (!rtc) {
    return false;
  }
  if (typeof rtc.isEstablished === "function") {
    return rtc.isEstablished();
  }
  const status = rtc.status ?? rtc._status;
  return status === 5 || status === 6 || status === 9;
};

export const canRtcSessionAnswer = (session) => {
  const rtc = getRtcSession(session);
  if (!rtc) {
    return true;
  }
  if (typeof rtc.isEstablished === "function" && rtc.isEstablished()) {
    return false;
  }
  if (typeof rtc.isInProgress === "function") {
    return rtc.isInProgress();
  }
  const status = rtc.status ?? rtc._status;
  return status === 3 || status === 4;
};

export const toLinkusError = (cause, fallbackMessage) => {
  if (cause instanceof Error) {
    return cause;
  }
  const message =
    cause?.message ||
    cause?.cause ||
    (typeof cause === "string" ? cause : null) ||
    fallbackMessage;
  return new Error(message);
};
